export default (theme) => ({
    chatButtons: {
        display: 'flex',
        gap: 8,
        marginBottom: 8,
    },
    errorContainer: {
        alignItems: 'center',
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        maxWidth: 'calc(100% - 88px)',
        minHeight: 58,
        padding: 8,
    },
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        gap: 8,
        width: '100%',
        overflow: 'hidden',
        '& > [class*="InputWrapper__root"]:not(:only-child)': {
            maxWidth: 'calc(100% - 48px)',
        },
        '& > [class*="CopilotVoiceRecording__root"]': {
            maxWidth: 'calc(100% - 150px)',
        },
        '& [class*="InputWrapper__formControl"]': {
            width: '100%',
        },
        '& [class*="HoiPoi__RichText__editor"]': {
            transition: 'initial',
        },
        '& [class*="HoiPoi__CopilotClearButton"]': {
            marginBottom: 8,
        },
    },
    hasUserMessages: {
        '& > [class*="InputWrapper__root"]': {
            maxWidth: 'calc(100% - 96px)',
        },
    },
});
